/**
 * Help centre — FAQ and contact information.
 */
import { PageHead } from "../components/PageHead";
import { BookOpen, MessageSquare, Phone, Mail, Clock } from "lucide-react";
import { faqs as faqsData } from "@evocha/mock-data";

const faqs = faqsData;

export function Help() {
  return (
    <>
      <PageHead
        title="Help Centre"
        description="FAQs, contact information, and operational guides."
      />

      <div className="admin-help-grid">
        <div className="admin-card" style={{ padding: 24 }}>
          <h3 style={{ marginBottom: 20, display: "flex", alignItems: "center", gap: 10 }}>
            <BookOpen size={20} style={{ color: "var(--ev-blue-600)" }} />
            Frequently Asked Questions
          </h3>
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            {faqs.map((faq, i) => (
              <div key={i} style={{ paddingBottom: 16, borderBottom: "1px solid var(--ev-border)" }}>
                <div className="ev-body-semibold">{faq.q}</div>
                <div className="ev-body-muted" style={{ marginTop: 6, lineHeight: 1.6 }}>{faq.a}</div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div className="admin-card" style={{ padding: 20 }}>
            <h3 style={{ marginBottom: 16 }}>Contact</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {[
                { icon: <MessageSquare size={18} />, label: "WhatsApp", value: "+255 700 000 000" },
                { icon: <Mail size={18} />, label: "Email", value: "ops@skttanzania.co.tz" },
                { icon: <Phone size={18} />, label: "Phone", value: "+255 700 000 000" },
                { icon: <Clock size={18} />, label: "Support Hours", value: "Mon-Fri 8am-6pm EAT" },
              ].map((c, i) => (
                <div key={i} style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                  <span style={{ color: "var(--ev-slate-400)", marginTop: 2 }}>{c.icon}</span>
                  <div>
                    <div className="ev-body-micro-muted">{c.label}</div>
                    <div className="ev-body">{c.value}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
